import { useChat } from '../../context/ChatContext';

type ChatButtonProps = {
    value: string;
    className?: string;
    /** Defaults to "Ask AI Co-pilot" */
    label?: string;
};

const ChatButton = (props: ChatButtonProps) => {
    const { toggleChat } = useChat();
    return (
        <button
            type="button"
            className={props.className || "btn-ai-copilot"}
            onClick={() => toggleChat(props.value)}
        >
            <i className="fa-kit fa-ai-stars" aria-hidden="true"></i>
            {props.label ?? 'Ask AI Co-pilot'}
        </button>
    );
};

export default ChatButton;
